define('app/factories/minicart_factory',['app/setup', 'app/models/minicart', 'app/views/minicart_view'],
  function(takhfifan, minicart, minicartView) {

    takhfifan.eventHub.on('cart', _.once(function(cart) {
      var minicart = new takhfifan.Minicart({
        quantity: cart.quantity,
        subtotal: cart.subtotal
      });

      $('.shopping-basket').each(function(){
        new takhfifan.MinicartView({
          el: $(this),
          model: minicart,
          items: cart.items
        });
      }, this);

    }));
});

